import React from 'react'
import TotalBatches from '../../components/Batches/TotalBatches'

const Batches = () => {
  return (
    <div>
        <TotalBatches/>
    </div>
  )
}

export default Batches